import { useTranslation } from 'react-i18next';

export const useManageTabLabels = (): string[] => {
  const { t } = useTranslation('manage_consultees');
  return [t('organisations', 'Organisations'), t('teams', 'Teams'), t('users', 'Users')];
};
